/* eslint-disable camelcase */
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import { get } from 'lodash-es'
import { normalize } from 'normalizr'
import API from '../config'
import { collection as collectionSchema } from '../schemas'
import { selectUser } from './user'
import { receiveCollections } from './userContent'
import { getHeaders } from './api'

const rootApi = `${API.apiPath}/${API.apiVersion}/`

export const REQUEST_SAVE_ADVANCED_SEARCH = 'REQUEST_SAVE_ADVANCED_SEARCH'
export const REQUEST_REMOVE_ADVANCED_SEARCH = 'REQUEST_REMOVE_ADVANCED_SEARCH'
export const REQUEST_ADVANCED_SEARCH = 'REQUEST_ADVANCED_SEARCH'
export const RECEIVE_ADVANCED_SEARCH = 'RECEIVE_ADVANCED_SEARCH'
export const REQUEST_ADVANCED_SEARCH_PARAMETERS = 'REQUEST_ADVANCED_SEARCH_PARAMETERS'
export const RECEIVE_ADVANCED_SEARCH_PARAMETERS = 'RECEIVE_ADVANCED_SEARCH_PARAMETERS'
export const RESET_CARDS = 'RESET_CARDS'

export function resetCards() {
  return {
    type: RESET_CARDS
  }
}

export function requestAdvancedSearchParameters(payload) {
  return {
    type: REQUEST_ADVANCED_SEARCH_PARAMETERS,
    payload
  }
}

function receiveAdvancedSearchParameters(payload) {
  return {
    type: RECEIVE_ADVANCED_SEARCH_PARAMETERS,
    payload
  }
}

function* getAdvancedSearchParametersSaga() {
  yield takeEvery(REQUEST_ADVANCED_SEARCH_PARAMETERS, getAdvancedSearchParameters)
}

function* getAdvancedSearchParameters(action) {
  const url = rootApi + 'custom-feed/get'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const params = {
    ...action.payload
  }
  const headers = getHeaders(token)
  try {
    const responseWithFeed = yield call([axios, 'get'], url, { headers, params })
    const searchParameters = responseWithFeed.data.feed.search_parameters
    if (searchParameters) {
      yield put(requestAdvancedSearch(searchParameters))
      yield put(receiveAdvancedSearchParameters(searchParameters))
    }
  } catch (err) {
  } finally {
  }
}

export function requestAdvancedSearch(payload) {
  return {
    type: REQUEST_ADVANCED_SEARCH,
    payload
  }
}

function receiveAdvancedSearch(payload) {
  return {
    type: RECEIVE_ADVANCED_SEARCH,
    payload
  }
}

function* getAdvancedSearchSaga() {
  yield takeEvery(REQUEST_ADVANCED_SEARCH, getAdvancedSearch)
}

function* getAdvancedSearch(action) {
  const url = rootApi + 'account/advanced-search'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const params = {
    ...action.payload,
    start: (action.payload && action.payload.start) || 0,
    limit: (action.payload && action.payload.limit) || 10,
    type: (action.payload && action.payload.type) || ''
  }
  const headers = getHeaders(token)
  try {
    const response = yield call([axios, 'post'], url, params, headers)
    const responseWithoutTags =
      response.data.hits &&
      response.data.hits.filter(item => {
        return item.item_type !== 'tags'
      })
    let normalizedData
    normalizedData = normalize(responseWithoutTags, [collectionSchema])
    yield put(receiveAdvancedSearch(normalizedData))
    yield put(receiveCollections(normalizedData))
  } catch (err) {
  } finally {
  }
}

export function requestSaveAdvancedSearch(payload) {
  return {
    type: REQUEST_SAVE_ADVANCED_SEARCH,
    payload
  }
}

export function requestRemoveAdvancedSearch(payload) {
  return {
    type: REQUEST_REMOVE_ADVANCED_SEARCH,
    payload
  }
}

function* saveAdvancedSearch(action) {
  const url = rootApi + 'custom-feed/create-or-update'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const params = {
    ...action.payload
  }
  const headers = getHeaders(token)

  try {
    const response = yield call([axios, 'post'], url, params, { headers })
    const feedUrl =
      '/search?type=advanced_search&id=' + response.data.feed.id + '----' + response.data.feed.name.replace(' ', '-')
    yield call(
      [axios, 'post'],
      url,
      {
        ...params,
        name: response.data.feed.name,
        feed_id: response.data.feed.id,
        feed_url: feedUrl
      },
      {
        headers
      }
    )
    if (!action.payload.feed_id) {
      window.location.href = feedUrl
    } else {
      window.location.reload()
    }
  } catch (err) {
  } finally {
  }
}

function* removeAdvancedSearch(action) {
  const url = rootApi + 'custom-feed/delete'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const params = {
    ...action.payload
  }
  const headers = getHeaders(token)

  try {
    yield call([axios, 'post'], url, params, { headers })
    window.location.href = '/search?type=advanced_search'
  } catch (err) {
  } finally {
  }
}

function* saveAdvancedSearchSaga() {
  yield takeLatest(REQUEST_SAVE_ADVANCED_SEARCH, saveAdvancedSearch)
}

function* removeAdvancedSearchSaga() {
  yield takeLatest(REQUEST_REMOVE_ADVANCED_SEARCH, removeAdvancedSearch)
}

export const sagas = [
  getAdvancedSearchSaga,
  saveAdvancedSearchSaga,
  removeAdvancedSearchSaga,
  getAdvancedSearchParametersSaga
]
